import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const actions = [
    {
      id: 1,
      label: "Verfügbarkeit aktualisieren",
      icon: "Settings",
      variant: "default",
      onClick: () => console.log('Update availability')
    },
    {
      id: 2,
      label: "Schicht tauschen",
      icon: "RefreshCw",
      variant: "outline",
      onClick: () => console.log('Swap shift')
    },
    {
      id: 3,
      label: "Zeitplan exportieren",
      icon: "Download",
      variant: "outline",
      onClick: () => console.log('Export schedule')
    },
    {
      id: 4,
      label: "Urlaub beantragen",
      icon: "Calendar",
      variant: "secondary",
      onClick: () => console.log('Request time off')
    }
  ];

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-semibold text-foreground mb-4">Schnellaktionen</h3>
      {actions?.map((action) => (
        <Button
          key={action?.id}
          variant={action?.variant}
          iconName={action?.icon}
          iconPosition="left"
          iconSize={16}
          onClick={action?.onClick}
          className="w-full justify-start"
        >
          {action?.label}
        </Button>
      ))}
    </div>
  );
};

export default QuickActions;